const MAX_FACE_BYTES = 500 * 1024;

const dataUrlBytes = (value: string) => {
  const base64 = value.split(',', 2)[1] || '';
  return Math.floor((base64.length * 3) / 4) - (base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0);
};

export function canvasToCameraJpeg(source: HTMLCanvasElement): string {
  let canvas = source;
  let quality = 0.82;
  for (let attempt = 0; attempt < 8; attempt += 1) {
    const encoded = canvas.toDataURL('image/jpeg', quality);
    if (dataUrlBytes(encoded) <= MAX_FACE_BYTES) return encoded;
    quality = Math.max(0.52, quality - 0.08);
    if (attempt >= 3) {
      const resized = document.createElement('canvas');
      resized.width = Math.max(480, Math.round(canvas.width * 0.82));
      resized.height = Math.max(480, Math.round(canvas.height * 0.82));
      const context = resized.getContext('2d');
      if (!context) throw new Error('No se pudo comprimir la fotografía facial.');
      context.drawImage(canvas, 0, 0, resized.width, resized.height);
      canvas = resized;
    }
  }
  throw new Error('No se pudo reducir la fotografía facial a menos de 500 KB.');
}
